export enum commonRoutes {
  HOME = '/',
  PORTFOLIO = '/portfolio',
  VAULTS = '/vaults',
  VAULTS_ITEM = '/vaults/:id',
  MARKET_DETAILS = '/market-details/:id',
  REFERRAL = '/ref',
  FAQ = '/faq',
  DOCS = '/documentation',
  TERM_OF_SERVICE = '/terms-of-service',
  PRIVACY_POLICY = '/privacy-policy',
  NOT_FOUND = '*',
}

export enum externalRoutes {
  TWITTER = 'https://x.com/mezzanine_fi',
  DISCORD = 'https://discord.gg/j27ARXEfvV',
  TELEGRAM = 'https://t.me/+JQ1q4Sg0bFYwZGU0',
  DEBANK = 'https://debank.com/',
}

export const getMarketDetailsPath = (id: string) => `/market-details/${id}`;
